import React from "react";
export default function Avatar() {
  return (
    <div className="h-[70px] w-[70px] rounded-full border border-[#C8CDD4] grid place-items-center">
      <span className="material-icons text-5xl">person</span>
    </div>
  );
}
